import React from "react";
import Loadable from "../../react-loadable";

const WeaTreeNew = Loadable({
  loader: () => import("./TreeNew"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default WeaTreeNew;



// WEBPACK FOOTER //
// ./ecology9/wea-tree-new/index.js